import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Truck, FileText, Package, ClipboardList } from "lucide-react";
import DeliveryScheduleTab from "./DeliveryScheduleTab";
import InvoiceGenerationTab from "./InvoiceGenerationTab";
import SampleIssueTab from "./SampleIssueTab";
import ItemCreationTab from "./ItemCreationTab";

const DistributionDashboard = () => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const DEPARTMENT_NO =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const [activeTab, setActiveTab] = useState(0);

  // // Handle transfer from DO to Sales Invoice
  // const handleTransferFromDO = (transferData) => {
  //   console.log("Transfer Data from DO:", transferData);

  // };

  const tabs = [
    { icon: Truck, label: "Delivery Schedule" },
    { icon: FileText, label: "Invoice Generation" },
    { icon: Package, label: "Sample Issue" },
    { icon: ClipboardList, label: "Item Creation Request" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <DeliveryScheduleTab
            COMPANY_CODE={COMPANY_CODE}
            DEPARTMENT={DEPARTMENT_NO}
            BASE_URL={BASE_URL}
          />
        );
      case 1:
        return (
          <InvoiceGenerationTab
            COMPANY_CODE={COMPANY_CODE}
            DEPARTMENT={DEPARTMENT_NO}
            BASE_URL={BASE_URL}
            // onTransfer={handleTransferFromDO}
          />
        );
      case 2:
        return (
          <SampleIssueTab
            DEPARTMENT={DEPARTMENT_NO}
            COMPANYCODE={COMPANY_CODE}
            BASE_URL={BASE_URL}
          />
        );
      case 3:
        return (
          <ItemCreationTab BASE_URL={BASE_URL} COMPANY_CODE={COMPANY_CODE} />
        );
      default:
        return null;
    }
  };
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 overflow-hidden">
      <div className="text-black">
        <div className="flex items-center gap-3">
          <h1 className="text-lg font-semibold px-4">
            Distribution Management
          </h1>
        </div>
      </div>

      {/* Compact Tabs */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="px-4 flex">
          {tabs.map((tab, index) => {
            const Icon = tab.icon;
            return (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`flex items-center gap-1.5 px-4 py-2.5 text-sm transition-all border-b-2 ${
                  activeTab === index
                    ? "text-cyan-600 border-cyan-600 font-semibold"
                    : "text-gray-600 border-transparent hover:text-cyan-600 hover:bg-gray-50"
                }`}
              >
                <Icon size={14} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Delivery Tab Component */}
      {renderTabContent()}
    </div>
  );
};

export default DistributionDashboard;
